import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import RecapReplenishment from 'components/Content/Recap/RecapReplenishment/RecapReplenishment';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import RecapEN from 'components/Content/Recap/locales/Recap_en_US';
import RecapFR from 'components/Content/Recap/locales/Recap_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(RecapEN, RecapFR);

const localization = createStructuredSelector({
    productImage: getTextFromResource(getText, 'productImage')
});

const fields = createSelector(localization, locale => {
    return { localization: locale };
});

const withRecapReplenishmentProps = wrapHOC(connect(fields, null));

export default withRecapReplenishmentProps(RecapReplenishment);
